// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM9.52513 14.4756C8.15829 13.1088 8.15829 10.8927 9.52513 9.52586C10.892 8.15902 13.108 8.15902 14.4749 9.52586L15.182 10.233L16.5962 8.81875L15.8891 8.11165C13.7412 5.96376 10.2588 5.96376 8.11091 8.11165C5.96303 10.2595 5.96303 13.7419 8.11091 15.8898C10.2588 18.0377 13.7412 18.0377 15.8891 15.8898L16.5962 15.1827L15.182 13.7685L14.4749 14.4756C13.108 15.8424 10.892 15.8424 9.52513 14.4756Z"}}]};

const CopyrightFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'copyright-filled',
    ref,
    icon: element,
  },
));

CopyrightFilledIcon.displayName = 'CopyrightFilledIcon';

export default CopyrightFilledIcon;
